import { baseApi } from "@/redux/api/baseApi";
import { TJobsResponse } from "./jobsType";
import { FileDetails } from "../scriptDetails/scriptDetailsSlice";

export interface AcceptJobPayload {
  video_ids: string[];
  email: string;
  deliverables?: string;
  isSelectedForMultipleVideos: boolean;
  order_id: string;
  actor_id?: string;
  supportingCastVideos?: {
    role?: string;
    video?: FileDetails;
    hash?: string;
    thumbnail?: string;
  }[];
}

interface AcceptJobResponse {
  success: boolean;
  message?: string;
}
export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};

export const CREATOR_JOBS_STALE_SECONDS = 60;

export type CreatorJobsSort =
  | "available"
  | "applied"
  | "invited"
  | "same_day";

export const buildCreatorJobsQueryParams = ({
  email,
  sort,
  page = 1,
  limit = 10,
  pinOrderId,
  search,
  refresh,
}: {
  email?: string;
  sort: CreatorJobsSort;
  page?: number;
  limit?: number;
  pinOrderId?: string;
  search?: string;
  /** Set when user explicitly refreshes — backend skips Redis cache. */
  refresh?: string | number;
}): TQueryParam[] => {
  const params: TQueryParam[] = [
    { name: "sort", value: sort },
    { name: "limit", value: limit },
    { name: "page", value: page.toString() },
  ];

  if (email) {
    params.unshift({ name: "email", value: email });
  }
  if (pinOrderId) {
    params.push({ name: "pinOrderId", value: pinOrderId });
  }
  if (search) {
    params.push({ name: "search", value: search });
  }
  if (refresh != null && String(refresh).length > 0) {
    params.push({ name: "refresh", value: String(refresh) });
  }

  return params;
};

const jobsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreatorJobs: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: "/creator-job/get-creator-jobs-v2",
          method: "GET",
          params: params,
        };
      },
      providesTags: ["CreatorJobs"],
    }),

    // acceptJob: builder.mutation({
    //   query: ({ order_id, video_id, actor_id }) => ({
    //     url: `/creator-canvas/apply-actor/${order_id}/${video_id}/${actor_id}`,
    //     method: "POST",
    //   }),
    //   invalidatesTags: ["CreatorJobs", "CreatorProjects"],
    // }),
    applyToJob2: builder.mutation<AcceptJobResponse, AcceptJobPayload>({
      query: (body) => ({
        url: `/creator-canvas/apply-actor-v2`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["CreatorJobs", "CreatorProjects"],
    }),
  }),
});

export const {
  useGetCreatorJobsQuery,
  // useAcceptJobMutation,
  useApplyToJob2Mutation,
} = jobsApi;

export { jobsApi };
